module.exports = __webpack_public_path__ + "static/img/m_name.b2b017b.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/cz/m_name.png
// module id = +IH0
// module chunks = 7